const styles = {
  link: {
    cursor: "pointer",
    textDecoration: "none",
    fontWeight: 600,
    color: "#2a61dd",
  },
};

export default styles;
